import { getUnpickedColumns } from './getFields';
import { ISectionData } from '../KolumnValjare';
import { IAvenyModelContext } from '../../../Model/ModelContext/ModelContext';
import { ITreeSection } from '../../../BaseComponents/TreeSelect/TreeSelectUtils';
import { IColumnDef } from '../../../Types/ColumnDefType';

const removeAssociationPrefix = (associationPath: string): string => {
  return associationPath.replace('&association-', '');
};

const getSublist = (
  context: IAvenyModelContext,
  pickedColumns: ITreeSection<ISectionData>[],
  column: ITreeSection<ISectionData>
) => {
  return getUnpickedColumns(
    context.avenyCollectionMap,
    pickedColumns,
    column.data?.associatedCollectionName || '',
    column.data?.associatedComponentName || '',
    removeAssociationPrefix(column.data?.path || '') + '.',
    column.value + '.'
  );
};

export const fillSublists = (
  context: IAvenyModelContext,
  list: ITreeSection<ISectionData>[],
  pickedColumns: ITreeSection<ISectionData>[]
): ITreeSection<ISectionData>[] => {
  return list.reduce(
    (a: ITreeSection<ISectionData>[], b: ITreeSection<ISectionData>) => {
      const idPaths = b.data?.path.split('.') || '';

      const fillSublist = idPaths.length <= 2 || b.open;

      if (b.data?.isExpandable && !b.data?.isAttributeGroup && fillSublist) {
        const subList = getSublist(context, pickedColumns, b);
        b.subList = fillSublists(context, subList, pickedColumns);
      }

      a.push(b);
      return a;
    },
    []
  );
};

export const closeChildExpandables = (list: ITreeSection<ISectionData>[]) => {
  list.forEach(x => {
    if (x.data?.fieldType === 'expandable') {
      x.open = false;
      closeChildExpandables(x.subList ?? []);
    }
  });
};

export const uncheckSection = (value: string, sections: ITreeSection[]) => {
  for (let i = 0; i < sections.length; i++) {
    const section = sections[i];
    if (section.subList) {
      uncheckSection(value, section.subList);
    } else if (section.value === value) {
      section.checked = false;
      break;
    }
  }
};

export const applyCheckedState = (
  sections: ITreeSection<ISectionData>[],
  valdaKolumner: readonly IColumnDef[]
): ITreeSection<ISectionData>[] => {
  const valdaSet = new Set(valdaKolumner.map(v => v.attributeDef));
  const headerSet = new Set(
    valdaKolumner.filter(v => v.header).map(v => v.attributeDef)
  );

  const applyNode = (
    node: ITreeSection<ISectionData>
  ): ITreeSection<ISectionData> => {
    const newNode = { ...node };
    if (node.data?.fieldType === 'attribute') {
      newNode.checked = valdaSet.has(node.value);
      const isHeader = headerSet.has(node.value);
      newNode.disabled = isHeader ? { value: true, tooltip: '' } : undefined;
    }
    if (node.subList) {
      newNode.subList = node.subList.map(applyNode);
    }
    return newNode;
  };

  return sections.map(applyNode);
};
